export const SOCIAL_MEDIA_LINKS = {
    facebook: 'https://www.facebook.com/uniracinc/',
    twitter: 'https://twitter.com/Unirac',
    linkedin: 'https://www.linkedin.com/company/unirac-inc-/',
    instagram: 'https://www.instagram.com/uniracsolar/',
    youtube: 'https://www.youtube.com/user/uniracsolar1/'
}